const identityAccessComponentLoaders = Object.freeze({
  'identity-access.roster-workspace': async () => {
    const module = await import('./identity-roster-workspace-component.js');
    return module.IdentityRosterWorkspaceComponent;
  },
});

export default identityAccessComponentLoaders;
